import React from 'react'
import './change-professional-card.css'
import { HiHand, HiOutlinePencil } from "react-icons/hi";
import { useNavigation } from "../../../hooks/navigationContext";
import { useNavigate } from 'react-router-dom'

const ChangeProfessionalCard = ({ Action, Description, Duration, Price, URLPicture }) => {

    const navigate = useNavigate();
    const { setDirection } = useNavigation();

    const action = () => {
        setDirection(-1);
        navigate(Action);
    }

    return (
        <div>
            <button className='change-professional-card' onClick={action}>

{/*                 <div className="card-icon">
                    <HiHand />
                </div> */}

                <div className="content">
                    <p className='app-little-title'>{Description}</p>
                    <div className="professional-details">
                        <span className='clock'>⏱ </span>
                        <span className='app-little-text '>{Duration}</span>
                        <span className="app-little-text">•</span>
                        <span className="app-little-text price">{Price}</span>
                    </div>
                </div>

                <div class="divider"></div>

                <div className="icon">
                    <img src={URLPicture} alt="Serviço" />
                </div>

                <div className="content">
                    <p className='app-little-title'>Juliana Silva</p>
                    <div className="professional-details">
                        <span className='app-little-text '>Colorista</span>
                    </div>
                </div>

                <div className="change-icon">
                    Alterar <HiOutlinePencil />
                </div>
            </button>
        </div>
    )
}

export default ChangeProfessionalCard